import { Dispatch } from 'redux';
import { scheduleActions } from '../slices/schedule-slice';
import { ApiSchedule } from '../http';
import { dateFormat } from '../hooks';

const {
  setScheduleRequestStart,
  setScheduleRequestSuccess,
  setScheduleRequestFailure,
  setScheduleRequestDefault,

  setScheduleListRequest,
  setScheduleListSuccess,
  setScheduleListFailure,
  setScheduleListDefault,

  setScheduleOneRequest,
  setScheduleOneSuccess,
  setScheduleOneFailure,
  setScheduleOneDefault,
} = scheduleActions;

//List
export const getSchedules = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleListRequest());
  try {
    const data = await ApiSchedule.fetchAll(params);
    dispatch(setScheduleListSuccess(data));
  } catch ({ message }) {
    dispatch(setScheduleListFailure({ message }));
  }
};
export const clearSchedules = () => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleListDefault());
};

//One
export const getSchedule =
  (id: string | number, params?: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setScheduleOneRequest());
    try {
      const data = await ApiSchedule.fetchOne(id, params);
      dispatch(setScheduleOneSuccess(data));
    } catch ({ message }) {
      dispatch(setScheduleOneFailure({ message }));
    }
  };
export const clearSchedule = () => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleOneDefault());
};

//Create
export const createSchedule = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleRequestStart());
  return new Promise((resolve, reject) => {
    if (data.date && data.time) {
      const newDate = dateFormat(new Date(data.date), 'Y-M-D');
      data.date = new Date(newDate + ' ' + data.time).toISOString();
    } else if (data.date) {
      data.date = new Date(data.date).toISOString();
    }
    ApiSchedule.createOne(data)
      .then((res) => {
        dispatch(setScheduleRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setScheduleRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editSchedule =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setScheduleRequestStart());
    return new Promise((resolve, reject) => {
      if (data.date && data.time) {
        const newDate = dateFormat(new Date(data.date), 'Y-M-D');
        data.date = new Date(newDate + ' ' + data.time).toISOString();
      } else if (data.date) {
        data.date = new Date(data.date).toISOString();
      }
      ApiSchedule.updateOne(id, data)
        .then((res) => {
          dispatch(setScheduleRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setScheduleRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteSchedule = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleRequestStart());
  return new Promise((resolve, reject) => {
    ApiSchedule.deleteOne(id)
      .then((res) => {
        dispatch(setScheduleRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setScheduleRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearScheduleRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setScheduleRequestDefault());
};
